export default function (i) {
  if(typeof i === "string") {
    i = parseInt(i, 10);
  }
  switch (i) {
    case 1:
      return "ersten";
    case 2:
      return "zweiten";
    case 3:
      return "dritten";
    case 4:
      return "vierten";
    case 5:
      return "fünften";
    case 6:
      return "sechsten";
    case 7:
      return "siebten";
    case 8:
      return "achten";
    case 9:
      return "neunten";
    case 10:
      return "zehnten";
    case 11:
      return "elften";
    case 12:
      return "zwölften";
    case 13:
      return "dreizehnten";
    case 14:
      return "vierzehnten";
    case 15:
      return "fünzehnten";
    case 16:
      return "sechzenten";
    default:
      return i + ".";
  }
}



// WEBPACK FOOTER //
// ./src/Zaehler.js